module.exports = __webpack_public_path__ + "img/icon2.4245adf7.png";